import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { connect } from "react-redux";

class PhoneInputBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: true,
    };
  }

  componentDidMount() {
    if (this.props.notMandatory && this.props.validateFields) {
      this.props.validateFields.push({
        key: this.props.id,
        isValid: true,
        message: true,
        notMandatory: true,
        label: this.props.label,
      });
      this.props.errorFn(this.props.validateFields);
    } else if (this.props.validateFields) {
      this.props.validateFields.push({
        key: this.props.id,
        isValid: false,
        message: false,
        label: this.props.label,
      });
      this.props.errorFn(this.props.validateFields);
    }
    if (this.props.value && this.props.value !== "") {
      this.props.errorFn &&
        this.props.errorFn(
          this.getValidateFileds(this.props.id, false, false, true)
        );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.value &&
      nextProps.value !== "" &&
      this.props.validateFields &&
      this.state.flag
    ) {
      this.props.errorFn(
        this.getValidateFileds(this.props.id, false, false, true)
      );
      this.setState({ flag: false });
    }
  }

  loadTranslations = (value, currentLanguage) => {
    const currentLang = currentLanguage ? currentLanguage : "de";
    return this.props.translations
      ? this.props.translations[value]
        ? this.props.translations[value][currentLang]
          ? this.props.translations[value][currentLang]
          : value
        : value
      : value;
  };

  checkDuplicateEmail = (data, column) => {
    if (data.message === "success") {
      this.props.errorFn(
        this.getValidateFileds(
          column,
          "This email is already registered with us",
          false,
          false
        )
      );
    } else {
      this.props.errorFn(this.getValidateFileds(column, false, false, true));
    }
  };

  checkDuplicateUsername = (data, column) => {
    if (data.message === "success") {
      this.props.errorFn(
        this.getValidateFileds(
          column,
          "This username is already taken! please try some other",
          false,
          false
        )
      );
    } else {
      this.props.errorFn(this.getValidateFileds(column, false, false, true));
    }
  };

  checkJobRef = (data, column) => {
    if (data.message === "success") {
      this.props.errorFn(
        this.getValidateFileds(
          column,
          "This reference code is already taken",
          false,
          false
        )
      );
    } else {
      this.props.errorFn(this.getValidateFileds(column, false, false, true));
    }
  };

  checkDuplicateBusiness = (data, column) => {
    if (data.message === "success") {
      this.props.errorFn(
        this.getValidateFileds(
          column,
          "This business is already registered with us",
          false,
          false
        )
      );
    } else {
      this.props.errorFn(this.getValidateFileds(column, false, false, true));
    }
  };

  checkSeries = (data, column) => {
    if (data.message === "success") {
      this.props.errorFn(
        this.getValidateFileds(
          column,
          "This series is already there in vaccination",
          false,
          false
        )
      );
    } else {
      this.props.errorFn(this.getValidateFileds(column, false, false, true));
    }
  };

  emailCheck = (value, column) => {
    var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailCheck = regExp.test(String(value).toLowerCase());
    if (emailCheck) {
      this.props.checkDuplicateEmail &&
        this.props.dispatch(
          this.props.checkDuplicateEmail(
            value,
            this.checkDuplicateEmail,
            column,
            this.props.businessId
          )
        );
      this.props.errorFn &&
        this.props.errorFn(this.getValidateFileds(column, false, false, true));
    } else {
      this.props.errorFn &&
        this.props.errorFn(
          this.getValidateFileds(column, "Invalid Email", false)
        );
    }
    this.props.onChange(value, column);
  };

  passwordCheck = (value, column) => {
    if (value.length <= 5) {
      this.props.errorFn &&
        this.props.errorFn(
          this.getValidateFileds(column, "Weak password", false, false)
        );
    } else if (value.length >= 6 && value.length <= 9) {
      this.props.errorFn &&
        this.props.errorFn(
          this.getValidateFileds(column, "Medium password", false, false)
        );
    } else {
      this.props.errorFn &&
        this.props.errorFn(this.getValidateFileds(column, false, false, true));
    }
    this.props.onChange(value, column);
  };

  confirmPasswordCheck = (value, column) => {
    if (this.props.newPassword === value) {
      this.props.errorFn &&
        this.props.errorFn(this.getValidateFileds(column, false, false, true));
    } else {
      this.props.errorFn &&
        this.props.errorFn(
          this.getValidateFileds(
            column,
            "Confirm password not match with password",
            false,
            false
          )
        );
    }
    this.props.onChange(value, column);
  };

  urlCheck = (value, column) => {
    const url = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g;
    const checkUrl = url.test(value);
    if (checkUrl) {
      this.props.checkDuplicateEmail &&
        this.props.dispatch(
          this.props.checkDuplicateEmail(
            value,
            this.checkDuplicateEmail,
            column
          )
        );
      this.props.errorFn &&
        this.props.errorFn(this.getValidateFileds(column, false, false, true));
    } else {
      this.props.errorFn &&
        this.props.errorFn(
          this.getValidateFileds(column, "Invalid url", false)
        );
    }
    this.props.onChange(value, column);
  };

  businessCheck = (value, column) => {
    this.props.checkDuplicateBusiness &&
      this.props.dispatch(
        this.props.checkDuplicateBusiness(
          value,
          this.checkDuplicateBusiness,
          column
        )
      );
    this.props.checkDuplicateEmail &&
      this.props.dispatch(
        this.props.checkDuplicateEmail(
          this.props.email,
          this.checkDuplicateEmail,
          "email",
          value
        )
      );
    this.props.errorFn &&
      this.props.errorFn(this.getValidateFileds(column, false, false, true));
    this.props.onChange(value, column);
  };

  seriesCheck = (value, column) => {
    this.props.checkDuplicatieSeries &&
      this.props.dispatch(
        this.props.checkDuplicatieSeries(
          this.props.businessId,
          value,
          column,
          this.checkSeries
        )
      );
    this.props.onChange(value, column);
  };

  userNameCheck = (value, column) => {
    this.props.checkDuplicateUsername &&
      this.props.dispatch(
        this.props.checkDuplicateUsername(
          value,
          this.checkDuplicateUsername,
          column,
          this.props.businessId
        )
      );
    this.props.errorFn &&
      this.props.errorFn(this.getValidateFileds(column, false, false, true));
    this.props.onChange(value, column);
  };

  jobRefCheck = (value, column) => {
    this.props.checkJobRef &&
      this.props.dispatch(
        this.props.checkJobRef(
          value,
          this.props.businessId,
          this.checkJobRef,
          column
        )
      );
    this.props.errorFn &&
      this.props.errorFn(this.getValidateFileds(column, false, false, true));
    this.props.onChange(value, column);
  };

  onChangeText = (value, column) => {
    if (value === "" && this.props.notMandatory) {
      this.props.errorFn &&
        this.props.errorFn(this.getValidateFileds(column, false, false, true));
      this.props.onChange(value, column);
      return true;
    } else if (value === "" && !this.props.notMandatory) {
      const labelVal = column.charAt(0).toUpperCase() + column.slice(1);
      const lab = labelVal.split(/(?=[A-Z])/).join(" ");
      this.props.errorFn &&
        this.props.errorFn(this.getValidateFileds(column, lab, "is required"));
      this.props.onChange(value, column);
      return true;
    }
    if (value.length >= this.props.length) {
      this.props.errorFn(
        this.getValidateFileds(
          column,
          `More than ${this.props.length} charcters not allowed`,
          false,
          false
        )
      );
    } else {
      if (this.props.fieldType === "email") {
        this.emailCheck(value, column);
      } else if (
        this.props.fieldType === "password" &&
        !this.props.withoutStrength
      ) {
        this.passwordCheck(value, column);
      } else if (this.props.fieldType === "confirmPassword") {
        this.confirmPasswordCheck(value, column);
      } else if (this.props.fieldType === "url") {
        this.urlCheck(value, column);
      } else if (this.props.fieldType === "businessId") {
        this.businessCheck(value, column);
      } else if (this.props.fieldType === "series") {
        this.seriesCheck(value, column);
      } else if (this.props.fieldType === "userName") {
        this.userNameCheck(value, column);
      } else if (this.props.fieldType === "jobRef") {
        this.jobRefCheck(value, column);
      } else {
        this.props.onChange(value, column);
        this.props.errorFn &&
          this.props.errorFn(
            this.getValidateFileds(column, false, false, true)
          );
      }
    }
  };

  getValidateFileds = (column, message, message1, isValid) => {
    if (this.props.validateFields) {
      const fields = this.props.validateFields.map((data) => {
        if (data.key === column) {
          data["message"] = message;
          data["message1"] = message1;
          data["isValid"] = isValid;
          return data;
        } else {
          return data;
        }
      });
      return fields;
    } else {
      return this.props.validateFields;
    }
  };

  getMessage = () => {
    let message = false;
    if (this.props.validateFields && this.props.isSubmit) {
      this.props.validateFields.map((data) => {
        if (data.key === this.props.id) {
          if (data.message || data.message1) {
            message = { message: data.message, message1: data.message1 };
          }
        }
      });
    }
    return message;
  };

  render() {
    return (
      <div>
        {this.props.label && (
          <div className="login-input-text">
            {this.loadTranslations(
              this.props.label,
              this.props.currentLanguage
            )}{" "}
            {this.props.mandatory && "*"}{" "}
            {this.props.help && (
              <i
                title={this.props.help}
                class="fa fa-question-circle"
                aria-hidden="true"
              >
                {" "}
              </i>
            )}
          </div>
        )}
        {this.props.label && (
          <div style={{ minHeight: 14 }}>
            <div
              style={{
                color: "red",
                float: "right",
                fontSize: 12,
                paddingBottom: 2,
              }}
            >
              {this.getMessage() && (
                <span>
                  {" "}
                  <span>
                    {this.loadTranslations(
                      this.getMessage().message,
                      this.props.currentLanguage
                    )}
                  </span>{" "}
                  <span>
                    {this.loadTranslations(
                      this.getMessage().message1,
                      this.props.currentLanguage
                    )}
                  </span>
                </span>
              )}
            </div>
          </div>
        )}
        <PhoneInput
          country={this.props.country || "ch"}
          placeholder={this.props.placeholder}
          value={this.props.value}
          containerStyle={{
            border: this.getMessage() ? "2px solid red" : "1px solid #dfdce3",
          }}
          onChange={(phone) => this.onChangeText(phone, this.props.id)}
          inputStyle={{ width: "100%" }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.users.currentLanguage,
    translations: state.users.translations,
  };
}

export default connect(mapStateToProps)(PhoneInputBox);



// WEBPACK FOOTER //
// ./components/InputBox/PhoneInputBox.js